export const dashboard = ['dashboard']

export default [].concat(
    dashboard,
)
